export enum PresenterAccountStatus {
    Unknown = 0,
    ActiveTrial = 1,
    ActiveSubscriber = 2,
    InactiveTrial = 3,
    InactiveSubscriber = 4,
}

